export default __webpack_public_path__ + "static/media/galia-testimonial.307091c5.png";